import { FilterType, Filter, FilterKey } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '../../types';

const key = FilterKey.COURSE;
export const getCourseFilter = ({ activeFilters, filterOptions }: IGetFilterGroupsProps): Filter | null => {
  const filters = activeFilters[key] ?? [];
  const courseFilterOptions = filterOptions?.courses || [];
  const options = courseFilterOptions?.map((course: string) => {
    return {
      label: course,
      value: course,
      checked: filters.some(filter => filter === course),
    };
  });
  return {
    name: 'Course',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: options,
    },
  };
};
